import { useEffect } from 'react';
import ProductTemplate from '../template/templateNew';
import { ProductsCategory } from '../../../../config';
import { getProducts } from '../../../../commons/utils/productsHelper';
import { productsKeyConstants } from '../../../../config';
import { useAppSelector } from '../../../../src/app/hooks';
import { GAPageViewItem } from '../../../../commons/helpers/Analytics/googleAnalytics';
import { FBViewContent } from '../../../../commons/helpers/Analytics/fbPixel';
import { ipAddressInfo } from '../../../../src/features/user/userState';
import { PinterestPageVisit } from '../../../../commons/helpers/Analytics/pinterest';

export default function Index({ vwoClientInstance, userId }) {
  const products = getProducts();
  const ipaddress = useAppSelector(ipAddressInfo);
  const quickStartTag = productsKeyConstants.RF_RELIEF_FACTOR_60_CT;
  const rfsingleTag = productsKeyConstants.RF_RELIEF_FACTOR_60_CT_SINGLE;

  useEffect(() => {
    if (products) {
      GAPageViewItem([quickStartTag, rfsingleTag], products);
      PinterestPageVisit([quickStartTag, rfsingleTag], products);
    }
  }, [products]);

  useEffect(() => {
    if (ipaddress !== null) {
      FBViewContent([quickStartTag, rfsingleTag], products);
    }
  }, [ipaddress]);

  return (
    <>
      <ProductTemplate
        productType={ProductsCategory.RELIEF_FACTOR}
        vwoClientInstance={vwoClientInstance}
        userId={userId}
      />
    </>
  );
}
